<div class="min-h-screen flex flex-col">
  <nav class="fixed top-0 left-0 right-0 h-16 flex justify-between bg-base-200 items-center px-6 z-50">
    <div class="flex items-center space-x-4">
      <figure>
        <!-- Theme-aware APGAP logo: dark wordmark on the light theme, light wordmark on azdhs-dark -->
        <img
          src="/branding/logo/apgap-logo-horizontal-black.png"
          alt="apgap logo"
          class="h-9 w-auto p-1 dark:hidden"
        />
        <img
          src="/branding/logo/apgap-logo-horizontal-white.png"
          alt="apgap logo"
          class="hidden h-9 w-auto p-1 dark:block"
        />
      </figure>
      <div>
        <span class="font-bold text-lg text-primary">Arizona Pathogen Genomics Analytics Platform</span>
      </div>
    </div>
    <div class="flex items-center gap-3">
      <span class="text-primary-focus">Hello, {{ userSignal()?.email }}</span>
      <button
        type="button"
        class="btn btn-ghost btn-circle btn-sm text-primary"
        [attr.aria-label]="(isDark$ | async) ? 'Switch to light mode' : 'Switch to dark mode'"
        [attr.aria-pressed]="isDark$ | async"
        (click)="themeFacade.toggleTheme()"
      >
        @if (isDark$ | async) {
          <!-- Sun (Heroicons-style outline) to match the requested toggle look -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="w-5 h-5"
          >
            <path
              d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
            />
          </svg>
        } @else {
          <fa-icon [icon]="['fas', 'moon']"></fa-icon>
        }
      </button>
      <app-notification-bell></app-notification-bell>
      <app-help-button></app-help-button>
    </div>
  </nav>

  <app-lab-details-modal></app-lab-details-modal>
  <app-tour-welcome-modal></app-tour-welcome-modal>
  <app-tour-done-modal></app-tour-done-modal>

  <div class="flex flex-row flex-grow mt-16">
    <aside data-tour="sidebar" class="w-64 max-w-64 flex flex-col bg-base-200 border-r border-base-300 fixed left-0 top-16 bottom-0 overflow-hidden z-40">
      <!-- The active lab sits above the menu it scopes. -->
      <app-lab-switcher></app-lab-switcher>

      <div class="p-4 flex-1 overflow-y-auto max-w-full min-h-0">
        <app-sidenav></app-sidenav>
      </div>

      <div class="sticky bottom-0 bg-base-200">
        <app-system-alert-banner></app-system-alert-banner>
        <div class="border-t border-base-300">
          <app-side-bottom-menu></app-side-bottom-menu>
        </div>
      </div>
    </aside>

    <!-- min-w-0 lets this flex item shrink below its content's intrinsic width;
         without it, wide content (e.g. the Data Catalog table) forces the whole
         document past the viewport, which misaligns the fixed sidebar when the
         tour overlay is active. Horizontal overflow is contained in the scroll
         area below rather than the page. -->
    <main class="flex-1 min-w-0 bg-base-100 p-6 flex flex-col ml-64 mt-0">
      <app-lab-inactive-banner></app-lab-inactive-banner>

      @if (!hideBreadcrumb()) {
        <div class="mb-8 text-base font-bold text-primary">
          <xng-breadcrumb separator=" / "></xng-breadcrumb>
        </div>
      }

      <div class="flex-1 h-full min-w-0 overflow-auto">
        <router-outlet class="h-full w-full"></router-outlet>
      </div>
    </main>
  </div>
  <app-lab-sequence-drawer *ngIf="isDrawerOpenSignal()"></app-lab-sequence-drawer>
</div>
